<template>
	<div class="login">
		<h1 class="login-title">Login</h1>
		<input type="text" v-model="user_id" class="login-input" placeholder="User ID" />
		<input type="password" v-model="password" @keyup.enter="login()" class="login-input" placeholder="Password" />
		<input type="button" id="submit" @click="login()" value="Submit" class="login-button" />
		<!-- <input type="button" id="submit" @click="test()" value="Test" class="login-button" /> -->
		<p v-if="is_mobile" class="login-lost" style="margin-top:12px;"><a :href="mobileLoginUrl">Mobile Login</a></p>
	</div>
</template>

<script>
require('@/assets/css/login.css?ver=1.0');
import { apiLogin, apiTest } from '@/api/auth';
import { isMobile } from 'mobile-device-detect';

export default {
	data: function() {
		return {
			user_id: '',
			password: '',
			is_mobile: isMobile,

			backUri: null,

			menus: [],
		};
	},
	computed: {
		mobileLoginUrl() {
			var host = window.location.host;
			var url = process.env.VUE_APP_API_URL.includes('test') ? 'https://hair-mweb-test.bwisesoft.com/login_mobile' : 'https://hair-mweb.bwisesoft.com/login_mobile';
			// 서브도메인 = company_id (AuthController.getCompanyIdFromRemoteHost와 동일 규칙: -test/-temp 제거)
			if (host.indexOf('.bwisesoft.com') > -1) url += '?company_id=' + host.split('.')[0].replace(/-(test|temp)$/, '');
			return url;
		},
	},
	methods: {
		async test() {
			const { data } = await apiTest();
			console.log(data);
		},
		getAccess(path, operation) {
			var result = 'N';
			this.menus.forEach(m => {
				if (m.path == path) {
					if (operation == 'view') result = m.view_yn;
					else if (operation == 'modify') result = m.modify_yn;
				}
			});

			//console.log('result', result);
			return result;
		},
		setAccess(path, operation, yn, hide) {
			var found = false;
			this.menus.forEach(m => {
				if (m.path == path) {
					found = true;

					if (operation == 'view') m.view_yn = yn;
					else if (operation == 'modify') m.modify_yn = yn;

					//console.log('set', path, operation, yn);
				}
			});

			if (!found) {
				if (operation == 'view') this.menus.push({ path: path, view_yn: yn, hide: hide });
				else if (operation == 'modify') this.menus.push({ path: path, modify_yn: yn, hide: hide });
			}
		},
		async login() {
			const { data } = await apiLogin(this.user_id, this.password);
			//const response = await apiLogin(this.user_id, this.password);
			//console.log(response);
			//const data = response.data;
			//console.log(data);
			if (data.result == 'success') {
				//console.log(data.user);
				this.$session.start();
				this.$session.set('user', data.user);
				this.$session.set('company', data.company);
				this.$session.set('profile', data.profile);

				this.$session.set('auto_refresh', false);
				this.$session.set('balance_only', false);

				//console.log(this.$session.id());
				//console.log(data.user);
				//console.log(data.profile);
				//console.log(data.favMenuList);
				//this.$session.set('time_zone', data.user.time_zone);
				//console.log('time zone:', data.user.time_zone, data.user.company_time_zone);
				if (data.user.time_zone) {
					//console.log('setting user time zone', data.user.time_zone);
					this.$session.set('time_zone', data.user.time_zone);
					//this.$moment.tz.setDefault(data.user.time_zone);
				} else {
					//console.log('setting company time zone', data.user.company_time_zone);
					this.$session.set('time_zone', data.user.company_time_zone);
					//this.$moment.tz.setDefault(data.user.company_time_zone);
				}

				// if (data.user.company_id == 'newjigu') this.$store.commit('setClassHeader', 'Style');
				// if (data.user.company_id == 'newjigu') this.$session.set('headerClass', 'Style');
				// else this.$session.set('headerClass', 'Class');

				this.$session.set('headerClass', data.headerClass);

				//console.log(data.favMenuList);
				if (data.headerClass == 'Style') {
					data.favMenuList.forEach(m => {
						m.name = m.name.replace('Class', 'Style');
					});

					data.menuList.forEach(m => {
						m.name = m.name.replace('Class', 'Style');
					});
				}

				this.$session.set('favMenus', data.favMenuList);
				//this.$session.set('menus', data.menuList);
				this.menus = data.menuList;

				if (this.getAccess('/partner/customer_main', 'view') == 'Y') this.setAccess('/partner/partner_main', 'view', 'Y', true);
				if (this.getAccess('/partner/customer_main', 'modify') == 'Y') this.setAccess('/partner/partner_main', 'modify', 'Y', true);

				if (this.getAccess('/partner/vendor_main', 'view') == 'Y') this.setAccess('/partner/partner_main', 'view', 'Y', true);
				if (this.getAccess('/partner/vendor_main', 'modify') == 'Y') this.setAccess('/partner/partner_main', 'modify', 'Y', true);

				if (this.getAccess('/customer/add', 'view') == 'Y') this.setAccess('/partner/add', 'view', 'Y', true);
				if (this.getAccess('/customer/add', 'modify') == 'Y') this.setAccess('/partner/add', 'modify', 'Y', true);

				if (this.getAccess('/vendor/add', 'view') == 'Y') this.setAccess('/partner/add', 'view', 'Y', true);
				if (this.getAccess('/vendor/add', 'modify') == 'Y') this.setAccess('/partner/add', 'modify', 'Y', true);

				this.$session.set('menus', this.menus);

				if (this.backUri) this.$router.push(this.backUri);
				else if (data.user.home_path) this.$router.push(data.user.home_path);
				else this.$router.push('/');
			} else {
				this.$toast.error(data.msg);
			}

			// try {
			// 	//const { data } = await apiLogin(this.user_id, this.password);
			// 	const response = await apiLogin(this.user_id, this.password);
			// 	//console.log(response);
			// 	const data = response.data;
			// 	//console.log(data);
			// 	if (data.result == 'failure') {
			// 		//alert(data.msg);
			// 		console.log(data.msg);
			// 	} else {
			// 		// console.log('returend token:' + data.token);
			// 		// localStorage.setItem('token', data.token);
			// 		// this.$store.commit('getToken');
			// 		this.$session.start();
			// 		this.$router.push('/');
			// 	}
			// } catch (error) {
			// 	//console.log('Login error', error);
			// }
		},
	},
	mounted() {
		//console.log(this.$route.query);
		//if (this.$route.query.sessionExpired) console.log('session expired');
		//console.log(this.$route.sessionExpired);
		if (this.$session.exists()) {
			// if (this.$route.params.sessionExpired {
			if (this.$route.query.sessionExpired) {
				this.$session.destroy();
				this.$toast.error('Session expired. Relogin please.');
			} else {
				this.$router.push('/');
			}
		}
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;
	},
};
</script>

<style lang="scss"></style>
